module.exports = __webpack_public_path__ + "static/media/redwine.0b50bb72.jpg";